/**
 * Hidden Products JavaScript
 * Handles client-side hiding of products that should not be discoverable
 */

(function() {
  'use strict';
  
  // Get hidden product handles from theme settings
  const hiddenHandles = window.theme?.hiddenProductHandles || [];
  
  /**
   * Check if a product should be hidden based on its handle
   * @param {string} handle - Product handle to check
   * @returns {boolean} - True if product should be hidden
   */
  function isProductHidden(handle) {
    if (!handle || !hiddenHandles.length) return false;
    return hiddenHandles.includes(handle);
  }
  
  /**
   * Hide product elements from search results and collections
   */
  function hideHiddenProducts() {
    // Find all product links and check their handles
    const productLinks = document.querySelectorAll('a[href*="/products/"]');
    
    productLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;
      
      // Extract product handle from URL
      const match = href.match(/\/products\/([^?]+)/);
      if (!match) return;
      
      const handle = match[1];
      
      if (isProductHidden(handle)) {
        // Find the parent product container and hide it
        const productContainer = link.closest('.product-grid, .grid__item, .list-view-item, .product-card, [class*="product"]');
        if (productContainer) {
          productContainer.style.display = 'none';
        }
      }
    });
  }
  
  /**
   * Prevent navigation to hidden product pages
   */
  function preventHiddenProductNavigation() {
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a[href*="/products/"]');
      if (!link) return;
      
      const href = link.getAttribute('href');
      const match = href.match(/\/products\/([^?]+)/);
      if (!match) return;
      
      const handle = match[1];
      
      if (isProductHidden(handle)) {
        e.preventDefault();
        e.stopPropagation();
        
        // Redirect to 404 or home page
        window.location.href = '/404';
        return false;
      }
    });
  }
  
  /**
   * Initialize hidden products functionality
   */
  function init() {
    if (!window.theme?.enableHiddenProducts) return;
    
    // Hide products on page load
    hideHiddenProducts();
    
    // Prevent navigation to hidden products
    preventHiddenProductNavigation();
    
    // Re-hide products after AJAX updates (for search filters, etc.)
    document.addEventListener('DOMContentLoaded', hideHiddenProducts);
    
    // Listen for common AJAX completion events
    const ajaxEvents = ['ajaxComplete', 'filter:updated', 'search:updated', 'collection:updated'];
    ajaxEvents.forEach(eventName => {
      document.addEventListener(eventName, function() {
        setTimeout(hideHiddenProducts, 100);
      });
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
